/* eslint-disable */
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import currency symbol
import { currencySymbol } from "Config/Config";

const CostCalculationPopup = ({ costCalculationData }) => {
  const { t } = useTranslation(); //for translation
  const { screenHeight } = useContext(GlobalProvider);

  // Check if data is in loading state
  const isLoading = costCalculationData && costCalculationData.loading === true;
  const actualData = isLoading ? (costCalculationData.data || []) : (costCalculationData || []);

  //function to calculate total cost
  const calculateTotalCost = () => {
    if (!actualData || actualData.length === 0) return 0;
    
    return actualData.reduce((total, item) => {
      const itemTotal = parseFloat(item.educatorcost || item.totalfinalcost || item.totalcost?.totalcost || item.totalcost || 0);
      return total + itemTotal;
    }, 0).toFixed(2);
  };

  //function to get travel time (arrival + return)
  const getTravelTime = (item) => {
    const arrival = parseFloat(item.arrivaltime || 0);
    const returnTime = parseFloat(item.returntime || 0);
    return arrival + returnTime;
  };

  //function to get activity location
  const getActivityLocation = (item) => {
    return item.costlocation || item.activitylocation || item.locationzipcode || "-";
  };

  //function to get educator location
  const getEducatorLocation = (item) => {
    return item.educatorlocation || item.startzipcode || item.educatorzipcode || "-";
  };

  //function to check if item has error or is invalid
  const isItemError = (item) => {
    return item.error === true || (!item.customreserveid && !item.reserveid && !item.educatorname);
  };

  useEffect(() => {
    console.log("Cost Calculation Data:", costCalculationData);
  }, [costCalculationData]);

  return (
    <div
      className="offcanvas offcanvas-end border-0"
      tabIndex="-1"
      id="costCalculationPopup"
      aria-labelledby="costCalculationPopupLabel"
      style={{ width: "80%" }}
    >
      <div className="offcanvas-header px-4 py-3 bg-primary text-white">
        <h3 className="mb-0" id="costCalculationPopupLabel">
          {t("Reservation Cost Calculation")}
        </h3>
        <button
          type="button"
          className="btn-close p-2 bg-white shadow-none shadow-sm m-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body p-4 pt-0">
        {isLoading ? (
          <div className="mt-4">
            <div className="alert alert-info d-flex align-items-center" role="alert">
              <div className="spinner-border spinner-border-sm me-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <span>
                {t("Calculating costs")}... ({costCalculationData.current} / {costCalculationData.total})
              </span>
            </div>
            {actualData.length > 0 && (
              <div className="table-responsive">
                <table className="table table-bordered table-hover">
                  <thead className="table-light">
                    <tr>
                      <th>{t("Reserve ID")}</th>
                      <th>{t("Educator")}</th>
                      <th>{t("Activity Location")}</th>
                      <th>{t("Educator Location")}</th>
                      <th>{t("Distance")}</th>
                      <th>{t("Travel Time")} ({t("Min")})</th>
                      <th>{t("Activity Time")} ({t("Min")})</th>
                      <th>{t("Total Time")} ({t("Min")})</th>
                      <th>{t("Cost per hour")} ({currencySymbol})</th>
                      <th>{t("Total Cost")} ({currencySymbol})</th>
                    </tr>
                  </thead>
                  <tbody>
                    {actualData.length === 0 ? (
                      <tr className="table-danger">
                        <td colSpan="10" className="text-center text-danger fw-bold py-4">
                          {t("Error in cost calculation. Check if there is Educator with address and zipcode")}
                        </td>
                      </tr>
                    ) : (
                      actualData.map((item, index) => (
                        isItemError(item) ? (
                          <tr key={index} className="table-danger">
                            <td className="text-danger fw-bold">Error</td>
                            <td className="text-danger fw-bold">Error</td>
                            <td className="text-danger fw-bold">Error</td>
                            <td className="text-danger fw-bold">Error</td>
                            <td className="text-danger fw-bold">Error</td>
                            <td className="text-danger fw-bold">Error</td>
                            <td className="text-danger fw-bold">Error</td>
                            <td className="text-danger fw-bold">Error</td>
                            <td className="text-danger fw-bold">Error</td>
                            <td className="text-danger fw-bold">Error</td>
                          </tr>
                        ) : (
                          <tr key={index}>
                            <td>{item.customreserveid || item.reserveid || "-"}</td>
                            <td>{item.educatorname || "-"}</td>
                            <td>{getActivityLocation(item)}</td>
                            <td>{getEducatorLocation(item)}</td>
                            <td>{item.journeydistance || 0}</td>
                            <td>{getTravelTime(item) || 0}</td>
                            <td>{parseFloat(item.activitytime || item.minutes || 0)}</td>
                            <td>{parseFloat(item.totaltime || 0)}</td>
                            <td>{parseFloat(item.costperhour || 0)}</td>
                            <td className="fw-bold">
                              {parseFloat(item.educatorcost || item.totalfinalcost || item.totalcost?.totalcost || item.totalcost || 0)}
                            </td>
                          </tr>
                        )
                      ))
                    )}
                    {/* Placeholder rows for remaining items */}
                    {Array.from({ length: costCalculationData.total - actualData.length }).map((_, index) => (
                      <tr key={`placeholder-${index}`}>
                        <td colSpan="10">
                          <div className="placeholder-glow">
                            <span className="placeholder col-12"></span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ) : actualData ? (
          <>
            <div className="table-responsive mt-4">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>{t("Reserve ID")}</th>
                    <th>{t("Educator")}</th>
                    <th>{t("Activity Location")}</th>
                    <th>{t("Educator Location")}</th>
                    <th>{t("Distance")}</th>
                    <th>{t("Travel Time")} ({t("Min")})</th>
                    <th>{t("Activity Time")} ({t("Min")})</th>
                    <th>{t("Total Time")} ({t("Min")})</th>
                    <th>{t("Cost per hour")} ({currencySymbol})</th>
                    <th>{t("Total Cost")} ({currencySymbol})</th>
                  </tr>
                </thead>
                <tbody>
                  {actualData.length === 0 ? (
                    <tr className="table-danger">
                      <td colSpan="10" className="text-center text-danger fw-bold py-4">
                        {t("Error in cost calculation. Check if there is Educator with address and zipcode")}
                      </td>
                    </tr>
                  ) : (
                    actualData.map((item, index) => (
                      isItemError(item) ? (
                        <tr key={index} className="table-danger">
                          <td className="text-danger fw-bold">Error</td>
                          <td className="text-danger fw-bold">Error</td>
                          <td className="text-danger fw-bold">Error</td>
                          <td className="text-danger fw-bold">Error</td>
                          <td className="text-danger fw-bold">Error</td>
                          <td className="text-danger fw-bold">Error</td>
                          <td className="text-danger fw-bold">Error</td>
                          <td className="text-danger fw-bold">Error</td>
                          <td className="text-danger fw-bold">Error</td>
                          <td className="text-danger fw-bold">Error</td>
                        </tr>
                      ) : (
                        <tr key={index}>
                          <td>{item.customreserveid || item.reserveid || "-"}</td>
                          <td>{item.educatorname || "-"}</td>
                          <td>{getActivityLocation(item)}</td>
                          <td>{getEducatorLocation(item)}</td>
                          <td>{item.journeydistance || 0}</td>
                          <td>{getTravelTime(item) || 0}</td>
                          <td>{parseFloat(item.activitytime || item.minutes || 0)}</td>
                          <td>{parseFloat(item.totaltime || 0)}</td>
                          <td>{parseFloat(item.costperhour || 0)}</td>
                          <td className="fw-bold">
                            {parseFloat(item.educatorcost || item.totalfinalcost || item.totalcost?.totalcost || item.totalcost || 0)}
                          </td>
                        </tr>
                      )
                    ))
                  )}
                </tbody>
                <tfoot className="table-light">
                  <tr>
                    <td colSpan="9" className="text-end fw-bold">
                      {t("Total Cost")}:
                    </td>
                    <td className="fw-bold text-primary">
                      {calculateTotalCost()} {currencySymbol}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default CostCalculationPopup;
